<script>
	export let isChecked = false;
</script>

<div class="cbx">
  <input
		tabindex="-1"
		on:click={e => e.preventDefault()} id="cbx" type="checkbox" bind:checked={isChecked} class:shadow-lg={isChecked} />
  <label for="cbx"></label>
  <svg width="15" height="14" viewbox="0 0 15 14" fill="none">
    <path d="M2 8.36364L6.23077 12L13 2"></path>
  </svg>
</div>
